import React from "react";
import { Row, Col, Button } from "antd";
import { Swiper, SwiperSlide } from "swiper/react";
import { SendOutlined } from "@ant-design/icons";
import { SiHey } from "react-icons/si";
import Img1 from "../assets/testimonals/1.png";
import Img2 from "../assets/iconsmaking.png";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Autoplay, Pagination, Navigation } from "swiper/modules";
// import { AlignCenter } from 'lucide-react';

function Feedback() {
  return (
    <>
      <section className="main-feedback pt-40 pb-40 bg-[#6cc5bf]">
        <div className="container">
          <Row gutter={[12, 12]} align="middle" justify="center">
            <Col span={12}>
              <div className="main-feedback-tex">
                <h5 className="font-custom text-start text-3xl pb-5 text-[#fff]">
                  <span className="text-[#fff] text-5xl ">_</span> Valuable
                  Feedback
                </h5>
                <h2
                  style={{ lineHeight: "70px" }}
                  className="font-custom font-bold text-start text-5xl text-[#fff] w-[80%]"
                >
                  High Quality Printing Service In California
                </h2>
                <p className="text-[#fff] font-outfit text-[20px] w-[60%] pt-5">
                  Beautiful, customizable template, with a ton of blocks to
                  create an amazing website that
                </p>
                <Button
                  className="relative font-custom text-lg font-semibold
                                                      overflow-hidden border-2 border-teal-400 rounded-full
                                                      px-6 h-[45px] transition-all duration-300 ease-in-out
                                                      text-teal-600 bg-white hover:!bg-[#6cc5bf] hover:!border-[#000]
                                                      hover:!text-white shadow-[6px_6px_0_0_#14b8a6]
                                                      hover:shadow-[0px_0px_0_0_#14b8a6]
                                                      active:shadow-[0_2px_0_0_#14b8a6]
                                                      active:translate-y-[4px] group"
                  type="default"
                  icon={<SendOutlined />}
                  style={{
                    marginTop: 24,
                    borderRadius: "30px",
                    padding: "0 24px",
                    height: "45px",
                  }}
                >
                  Let’s Talk — Send A Message <SiHey />
                </Button>
              </div>
            </Col>
            <Col span={12}>
              <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                navigation={true}
                modules={[Autoplay, Pagination, Navigation]}
                className="mySwiper"
              >
                <SwiperSlide>
                  {" "}
                  <div className="silderfor p-5 ">
                    <div className="h-80 testimonals-bio p-5   rounded-lg bg-[#fff]">
                      <ul className="flex pb-5 pt-5  flex-row  align-items ">
                        <li className="mr-5 ml-5">
                          <img src={Img1} alt="" />
                        </li>
                        <li className="pl-3">
                          <h4 className="font-custom text-[25px] font-bold">
                            Mathias Herasen
                          </h4>
                          <p className="font-custom text-[18px] ">
                            Founder of{" "}
                            <span className="text-[#6cc5bf]">GamerPay</span>
                          </p>
                        </li>
                        <li className="ml-20">
                          <img src={Img2} alt="" />
                        </li>
                      </ul>
                      <p className="w-[70%] p-5 font-custom">
                        “I designed shirts for my family reunion, and the
                        results blew me away. The colors were vibrant, the
                        material was soft, and everyone loved them.”
                      </p>
                      <span className="text-[#6cc5bf] text-[20] font-custom p-5 ">
                        “ AMAZING SERVICE “
                      </span>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  {" "}
                  <div className="silderfor p-5 ">
                    <div className="h-80 testimonals-bio p-5   rounded-lg bg-[#fff]">
                      <ul className="flex pb-5 pt-5  flex-row  align-items ">
                        <li className="mr-5 ml-5">
                          <img src={Img1} alt="" />
                        </li>
                        <li className="pl-3">
                          <h4 className="font-custom text-[25px] font-bold">
                            Mathias Herasen
                          </h4>
                          <p className="font-custom text-[18px] ">
                            Founder of{" "}
                            <span className="text-[#6cc5bf]">GamerPay</span>
                          </p>
                        </li>
                        <li className="ml-20">
                          <img src={Img2} alt="" />
                        </li>
                      </ul>
                      <p className="w-[70%] p-5 font-custom">
                        “I designed shirts for my family reunion, and the
                        results blew me away. The colors were vibrant, the
                        material was soft, and everyone loved them.”
                      </p>
                      <span className="text-[#6cc5bf] text-[20] font-custom p-5 ">
                        “ AMAZING SERVICE “
                      </span>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  {" "}
                  <div className="silderfor p-5 ">
                    <div className="h-80 testimonals-bio p-5   rounded-lg bg-[#fff]">
                      <ul className="flex pb-5 pt-5  flex-row  align-items ">
                        <li className="mr-5 ml-5">
                          <img src={Img1} alt="" />
                        </li>
                        <li className="pl-3">
                          <h4 className="font-custom text-[25px] font-bold">
                            Mathias Herasen
                          </h4>
                          <p className="font-custom text-[18px] ">
                            Founder of{" "}
                            <span className="text-[#6cc5bf]">GamerPay</span>
                          </p>
                        </li>
                        <li className="ml-20">
                          <img src={Img2} alt="" />
                        </li>
                      </ul>
                      <p className="w-[70%] p-5 font-custom">
                        “I designed shirts for my family reunion, and the
                        results blew me away. The colors were vibrant, the
                        material was soft, and everyone loved them.”
                      </p>
                      <span className="text-[#6cc5bf] text-[20] font-custom p-5 ">
                        “ AMAZING SERVICE “
                      </span>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  {" "}
                  <div className="silderfor p-5 ">
                    <div className="h-80 testimonals-bio p-5   rounded-lg bg-[#fff]">
                      <ul className="flex pb-5 pt-5  flex-row  align-items ">
                        <li className="mr-5 ml-5">
                          <img src={Img1} alt="" />
                        </li>
                        <li className="pl-3">
                          <h4 className="font-custom text-[25px] font-bold">
                            Mathias Herasen
                          </h4>
                          <p className="font-custom text-[18px] ">
                            Founder of{" "}
                            <span className="text-[#6cc5bf]">GamerPay</span>
                          </p>
                        </li>
                        <li className="ml-20">
                          <img src={Img2} alt="" />
                        </li>
                      </ul>
                      <p className="w-[70%] p-5 font-custom">
                        “I designed shirts for my family reunion, and the
                        results blew me away. The colors were vibrant, the
                        material was soft, and everyone loved them.”
                      </p>
                      <span className="text-[#6cc5bf] text-[20] font-custom p-5 ">
                        “ AMAZING SERVICE “
                      </span>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  {" "}
                  <div className="silderfor p-5 ">
                    <div className="h-80 testimonals-bio p-5   rounded-lg bg-[#fff]">
                      <ul className="flex pb-5 pt-5  flex-row  align-items ">
                        <li className="mr-5 ml-5">
                          <img src={Img1} alt="" />
                        </li>
                        <li className="pl-3">
                          <h4 className="font-custom text-[25px] font-bold">
                            Mathias Herasen
                          </h4>
                          <p className="font-custom text-[18px] ">
                            Founder of{" "}
                            <span className="text-[#6cc5bf]">GamerPay</span>
                          </p>
                        </li>
                        <li className="ml-20">
                          <img src={Img2} alt="" />
                        </li>
                      </ul>
                      <p className="w-[70%] p-5 font-custom">
                        “I designed shirts for my family reunion, and the
                        results blew me away. The colors were vibrant, the
                        material was soft, and everyone loved them.”
                      </p>
                      <span className="text-[#6cc5bf] text-[20] font-custom p-5 ">
                        “ AMAZING SERVICE “
                      </span>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  {" "}
                  <div className="silderfor p-5 ">
                    <div className="h-80 testimonals-bio p-5   rounded-lg bg-[#fff]">
                      <ul className="flex pb-5 pt-5  flex-row  align-items ">
                        <li className="mr-5 ml-5">
                          <img src={Img1} alt="" />
                        </li>
                        <li className="pl-3">
                          <h4 className="font-custom text-[25px] font-bold">
                            Mathias Herasen
                          </h4>
                          <p className="font-custom text-[18px] ">
                            Founder of{" "}
                            <span className="text-[#6cc5bf]">GamerPay</span>
                          </p>
                        </li>
                        <li className="ml-20">
                          <img src={Img2} alt="" />
                        </li>
                      </ul>
                      <p className="w-[70%] p-5 font-custom">
                        “I designed shirts for my family reunion, and the
                        results blew me away. The colors were vibrant, the
                        material was soft, and everyone loved them.”
                      </p>
                      <span className="text-[#6cc5bf] text-[20] font-custom p-5 ">
                        “ AMAZING SERVICE “
                      </span>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  {" "}
                  <div className="silderfor p-5 ">
                    <div className="h-80 testimonals-bio p-5   rounded-lg bg-[#fff]">
                      <ul className="flex pb-5 pt-5  flex-row  align-items ">
                        <li className="mr-5 ml-5">
                          <img src={Img1} alt="" />
                        </li>
                        <li className="pl-3">
                          <h4 className="font-custom text-[25px] font-bold">
                            Mathias Herasen
                          </h4>
                          <p className="font-custom text-[18px] ">
                            Founder of{" "}
                            <span className="text-[#6cc5bf]">GamerPay</span>
                          </p>
                        </li>
                        <li className="ml-20">
                          <img src={Img2} alt="" />
                        </li>
                      </ul>
                      <p className="w-[70%] p-5 font-custom">
                        “I designed shirts for my family reunion, and the
                        results blew me away. The colors were vibrant, the
                        material was soft, and everyone loved them.”
                      </p>
                      <span className="text-[#6cc5bf] text-[20] font-custom p-5 ">
                        “ AMAZING SERVICE “
                      </span>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  {" "}
                  <div className="silderfor p-5 ">
                    <div className="h-80 testimonals-bio p-5   rounded-lg bg-[#fff]">
                      <ul className="flex pb-5 pt-5  flex-row  align-items ">
                        <li className="mr-5 ml-5">
                          <img src={Img1} alt="" />
                        </li>
                        <li className="pl-3">
                          <h4 className="font-custom text-[25px] font-bold">
                            Mathias Herasen
                          </h4>
                          <p className="font-custom text-[18px] ">
                            Founder of{" "}
                            <span className="text-[#6cc5bf]">GamerPay</span>
                          </p>
                        </li>
                        <li className="ml-20">
                          <img src={Img2} alt="" />
                        </li>
                      </ul>
                      <p className="w-[70%] p-5 font-custom">
                        “I designed shirts for my family reunion, and the
                        results blew me away. The colors were vibrant, the
                        material was soft, and everyone loved them.”
                      </p>
                      <span className="text-[#6cc5bf] text-[20] font-custom p-5 ">
                        “ AMAZING SERVICE “
                      </span>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
}

export default Feedback;
